import React, { ChangeEvent, useEffect, useState } from 'react';

import { FilePond, registerPlugin } from 'react-filepond';

import 'filepond/dist/filepond.min.css';

import { FilePondErrorDescription, FilePondFile } from 'filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

//const fr = require('filepond/locale/fr-fr.js');

import { Cancel, Edit, InsertDriveFile, PictureAsPdf, Replay } from '@mui/icons-material';
import { Button, ButtonProps, IconButton, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { AppState, FileInfo, UploadResponse, UploadState, UploaderStoreData, uploaderSlice } from 'cdx-common';
// @ts-ignore comment
import * as fr from 'filepond/locale/fr-fr';
import { useSelector } from 'react-redux';
import { useToaster } from '../../libraries/Toaster';
import { appStore } from '../../store';
import { ProgressIndicator } from './ProgressIndicator';

/**
 * Contains base64 image content of currently uploading files. This is to avoid
 * storing base64 content on the store. If page reloads, we loose data.
 */
export const base64ImagePreviews = new Map<string, string>();



registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

// react webcam !!! yeah -> https://www.npmjs.com/package/react-webcam
// autre source pour utiliser camera
// https://stackoverflow.com/questions/58806971/how-can-i-take-a-picture-in-react-web-application-not-native



export const FileUploader = (props: { multiple?: boolean, onChange?: (fileNames: string[]) => void, relation?: { type: string, id: ModelId; }; }) => {

    const [files, setFiles] = useState<FilePondFile[]>([]);

    useEffect(() => {
        if (props.onChange) {
            props.onChange(files.map(p => p.filename));
        }
    }, [files]);

    return <div><FilePond
        {...fr}
        files={files}
        onupdatefiles={setFiles}
        on
        allowMultiple={props.multiple === true}
        maxFiles={3}
        server={"/file/upload" + (props.relation ? ('/' + props.relation.type + '/' + props.relation.id) : '')}
        allowImagePreview={false}
        name="files" /* sets the file input name, it's filepond by default */
        labelIdle='Déplacez les fichiers ici ou <span class="filepond--label-action">choisir des fichiers</span>'
    /></div>;
};

export const PhotoUploader = (props: { multiple?: boolean, onUpload: (file: FileInfo) => void; }) => {

    const [uploadedFiles, setUploadedFiles] = useState<FileInfo[]>([]);
    const [files, setFiles] = useState<FilePondFile[]>([]);

    useEffect(() => {
        uploadedFiles.map(props.onUpload);

    }, [uploadedFiles]);

    const onProcessFile = (error: FilePondErrorDescription | null, file: FilePondFile) => {
        console.log('error', error);
        console.log('file', file);
        console.log('filename', file.filename);
        console.log('metadata', file.getMetadata());
        console.log('file', file.file);
        console.log('id', file.id);
    };

    return <div><FilePond
        {...fr}
        files={files}
        labelFileTypeNotAllowed={'Seules les images sont autorisées (JPG / PNG)'}
        acceptedFileTypes={['image/png', 'image/jpeg', 'image/jpg']}
        onupdatefiles={setFiles}
        onprocessfile={onProcessFile}
        allowMultiple={props.multiple === true}
        maxFiles={3}
        server={{
            process: {
                url: "/file/upload",
                onload: (res) => {
                    const serverResult: FileInfo = JSON.parse(res);
                    setUploadedFiles(currentFiles => [...currentFiles, serverResult]);
                    return res;
                }
            }
        }}
        allowImagePreview={false}
        name="files" /* sets the file input name, it's filepond by default */
        labelIdle='Déplacer les fichier ici ou <span class="filepond--label-action">choisir des images</span>'
    /></div >;
};


export const AWSImageButtonUploader = (props: ButtonProps & { onUpload: (info: FileInfo) => void; }) => {

    const [fileToUpload, setFileToUpload] = React.useState<File | undefined>();

    const onInputChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target?.files?.[0];
        if (file) {
            setFileToUpload(file);
        }
    };
    const { toast } = useToaster();
    const { onChange, ...buttonProps } = props;

    const onUpload = (file: FileInfo) => {
        props.onUpload(file);
    };

    const buttonContent = (uploadState: UploaderStoreData): React.ReactNode => {
        switch (uploadState.state) {
            case UploadState.ERROR:
                toast.error(`Impossible de charger l'image`);
                setFileToUpload(undefined);
                break;
            case UploadState.UPLOADING:
                return <ProgressIndicator value={Math.round((uploadState.loaded / uploadState.total) * 100)} />;

        }
        return <Edit />;
    };

    return <>
        <input
            type="file"
            accept='image/*'
            style={{ display: 'none' }}
            id="contained-button-file"
            onChange={onInputChange}
        />
        <label htmlFor="contained-button-file">
            <Button component="span" {...buttonProps}>
                {fileToUpload ? <AWSListUpoader file={fileToUpload} onUpload={onUpload} display={buttonContent} /> : <Edit />}
            </Button>
        </label>
    </>;
};

export const AWSListUpoader = (props: {
    file: File,
    onUpload: (info: FileInfo) => void,
    cancel?: () => void,
    display?: (data: UploaderStoreData) => React.ReactNode;
}) => {

    const [id, setUploadId] = React.useState<string>('');
    const uploadState = useSelector((state: AppState) => state.uploader.items[id]);



    const startUpoading = async () => {

        const data = new FormData();
        data.append('file', props.file);

        appStore.dispatch(uploaderSlice.actions.update({
            id,
            state: UploadState.UPLOADING,
            error: null
        }));


        try {
            const url: string = './file/up';

            /*
            // SIMPLE FETCH METHOD
            const rawResponse = await fetch(url, {
                method: 'POST',
                body: data,
            }); 
            const response = await rawResponse.json();
            */
            // XMLHTTP mode

            const xhr = new XMLHttpRequest();
            const response: UploadResponse = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        console.log("upload progress:", event.loaded / event.total);
                        appStore.dispatch(uploaderSlice.actions.update({
                            id,
                            loaded: event.loaded,
                            total: event.total
                        }));
                    }
                });
                xhr.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        appStore.dispatch(uploaderSlice.actions.update({
                            id,
                            loaded: event.loaded,
                            total: event.total
                        }));
                    }
                });
                xhr.addEventListener("loadend", () => {
                    resolve(xhr.readyState === 4 && xhr.status === 200 ? JSON.parse(xhr.response) : 'Erreur');
                });
                xhr.open("POST", url, true);
                xhr.send(data);
            });

            appStore.dispatch(uploaderSlice.actions.update({
                id,
                state: UploadState.UPLOADED,
                error: null,
                fileInfo: {
                    ...response,
                    uploadId: id
                }
            }));
            props.onUpload({
                ...response,
                uploadId: id
            });
        } catch (error) {
            appStore.dispatch(uploaderSlice.actions.update({
                id,
                state: UploadState.ERROR,
                error: JSON.stringify(error)
            }));
        }
    };


    React.useEffect(() => {
        if (!uploadState) return;
        switch (uploadState.state) {
            //case UploadState.UPLOADED:
            case UploadState.NONE:
                void startUpoading();
                break;
        }
    }, [uploadState]);

    React.useEffect(() => {
        if (!uploadState) {
            const id: string = crypto.randomUUID();
            appStore.dispatch(uploaderSlice.actions.set({
                id,
                fileName: props.file.name,
                state: UploadState.NONE,
                error: null,
                fileInfo: null,
                loaded: 0,
                total: 0,
                hasImagePreview: false
            }));
            setUploadId(id);
        }
    }, []);

    if (!uploadState) return;

    const secondaryAction = (): React.ReactNode => {
        switch (uploadState.state) {
            case UploadState.ERROR:
                return <IconButton edge='end' color='error'><Replay /></IconButton>;
            case UploadState.NONE:
                return props.cancel ? <IconButton edge='end' onClick={props.cancel}><Cancel /></IconButton> : null;
            case UploadState.UPLOADING:
                return uploadState.total ? <ProgressIndicator value={Math.round((uploadState.loaded / uploadState.total) * 100)} /> : null;
            default:
                return null;
        }
    };


    return props.display ? props.display(uploadState) : <ListItem secondaryAction={secondaryAction()}>
        <UploadItem cancel={props.cancel} file={props.file} state={uploadState?.state} />
    </ListItem>;
};

const UploadItem = (props: { file: File, state?: UploadState, cancel?: () => void; }) => {

    const getIcon = (): React.ReactNode => {
        if (props.file.type.includes('pdf')) {
            return <PictureAsPdf />;
        } else {
            return <InsertDriveFile />;
        }
    };

    if (props.file.type.includes('image')) {
        return <><ListItemIcon><UploadImage file={props.file} state={props.state} /></ListItemIcon><ListItemText style={{ opacity: props.state === UploadState.UPLOADED ? 1 : 0.5 }}>{props.file.name}</ListItemText></>;
    } else {
        return <><ListItemIcon style={{ opacity: props.state === UploadState.UPLOADED ? 1 : 0.5 }}>{getIcon()}</ListItemIcon><ListItemText style={{ opacity: props.state === UploadState.UPLOADED ? 1 : 0.5 }}>{props.file.name}</ListItemText></>;
    }
};
const UploadImage = (props: { file: File, state?: UploadState; }) => {

    const [base64Image, setBase64Image] = React.useState<string>('');
    const readImage = async () => {
        const fileReader = new FileReader();
        fileReader.onload = (fr) => {
            if (fr.loaded && typeof fileReader.result == 'string') {
                setBase64Image(fileReader.result);
            }
        };
        fileReader.readAsDataURL(props.file);
    };
    React.useEffect(() => {
        void readImage();
    }, []);
    return <img style={{
        width: '1em',
        height: '1em',
        opacity: props.state === UploadState.UPLOADED ? 1 : 0.5
    }} src={base64Image} />;
    /*
    return <div style={{
        display: 'flex',
        flex: 1,
        backgroundImage: base64Image ? 'url(' + base64Image + ')' : undefined,
        backgroundColor: 'grey',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
    }}></div>;
    */
};
